var map = {
	"./chicken/card1.png": 9673,
	"./chicken/card10.png": 5565,
	"./chicken/card11.png": 8084,
	"./chicken/card12.png": 543,
	"./chicken/card2.png": 5138,
	"./chicken/card3.png": 2619,
	"./chicken/card4.png": 356,
	"./chicken/card5.png": 7837,
	"./chicken/card6.png": 6598,
	"./chicken/card7.png": 5615,
	"./chicken/card8.png": 8136,
	"./chicken/card9.png": 6401,
	"./spinosaurus/card1.png": 5414,
	"./spinosaurus/card10.png": 7956,
	"./spinosaurus/card11.png": 4637,
	"./spinosaurus/card12.png": 3430,
	"./spinosaurus/card2.png": 2829,
	"./spinosaurus/card3.png": 1700,
	"./spinosaurus/card4.png": 3691,
	"./spinosaurus/card5.png": 34,
	"./spinosaurus/card6.png": 4041,
	"./spinosaurus/card7.png": 8288,
	"./spinosaurus/card8.png": 2119,
	"./spinosaurus/card9.png": 8478,
	"./trex/card1.png": 4167,
	"./trex/card10.png": 5319,
	"./trex/card11.png": 2830,
	"./trex/card12.png": 8581,
	"./trex/card2.png": 7132,
	"./trex/card3.png": 8757,
	"./trex/card4.png": 6698,
	"./trex/card5.png": 6531,
	"./trex/card6.png": 4552,
	"./trex/card7.png": 6593,
	"./trex/card8.png": 7814,
	"./trex/card9.png": 1615,
	"./triceratops/card1.png": 8476,
	"./triceratops/card10.png": 2182,
	"./triceratops/card11.png": 7279,
	"./triceratops/card12.png": 4820,
	"./triceratops/card2.png": 6583,
	"./triceratops/card3.png": 7358,
	"./triceratops/card4.png": 5073,
	"./triceratops/card5.png": 7592,
	"./triceratops/card6.png": 3347,
	"./triceratops/card7.png": 4490,
	"./triceratops/card8.png": 1085,
	"./triceratops/card9.png": 8052,
	"./velociraptor/Card1.png": 5802,
	"./velociraptor/Card10.png": 288,
	"./velociraptor/Card11.png": 2393,
	"./velociraptor/Card12.png": 8386,
	"./velociraptor/Card2.png": 4785,
	"./velociraptor/Card3.png": 6520,
	"./velociraptor/Card4.png": 1687,
	"./velociraptor/Card5.png": 8670,
	"./velociraptor/Card6.png": 469,
	"./velociraptor/Card7.png": 7404,
	"./velociraptor/Card8.png": 1003,
	"./velociraptor/Card9.png": 9874
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4396;